import { createTheme } from "@fluentui/react";
const expTheme = createTheme({
  palette: {
    neutralPrimary: "#000000"
  },
  semanticColors: {
    bodyText: "#000"
  }
});
export {
  expTheme
};
//# sourceMappingURL=AppTheme.js.map
